var map = {
	"./en/blog.json": 110,
	"./en/common.json": 111,
	"./en/courses/advance.json": 112,
	"./en/courses/basic.json": 113,
	"./en/download.json": 114,
	"./en/homepage.json": 115,
	"./en/products/addon-auto.json": 116,
	"./en/products/addon1.json": 117,
	"./en/products/book.json": 118,
	"./en/products/catalogue.json": 119,
	"./en/products/g-creator.json": 120,
	"./en/products/g-maker.json": 121,
	"./en/products/product_common.json": 122,
	"./en/solution.json": 123,
	"./en/training/lab.json": 124,
	"./en/training/teacher.json": 125,
	"./vi/blog.json": 126,
	"./vi/common.json": 127,
	"./vi/courses/advance.json": 128,
	"./vi/courses/basic.json": 129,
	"./vi/download.json": 130,
	"./vi/homepage.json": 131,
	"./vi/products/addon-auto.json": 132,
	"./vi/products/addon1.json": 133,
	"./vi/products/book.json": 134,
	"./vi/products/catalogue.json": 135,
	"./vi/products/g-creator.json": 136,
	"./vi/products/g-maker.json": 137,
	"./vi/products/product_common.json": 138,
	"./vi/solution.json": 139,
	"./vi/training/lab.json": 140,
	"./vi/training/teacher.json": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;